import { createI18n } from "vue-i18n";

import { fr as cfr, de as cde } from "@lde/core_lde_vue/dist/modules/i18n";
import { removeEmptyTradKeys } from "@lde/core_lde_vue/dist/modules/utils";

import { getBrowserLocale, supportedLocalesInclude } from "@/modules/utils";

const fr = require("@/locales/fr.json");
const de = require("@/locales/de.json");

// Pour fusionner deux objets en profondeur.
const merge = (target, source) => {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  Object.keys(source).forEach((key) => {
    if (source[key] instanceof Object) {
      Object.assign(source[key], merge(target[key], source[key]));
    }
  });

  // Join `target` and modified `source`
  Object.assign(target || {}, source);
  return target;
};

let locale = getBrowserLocale({ countryCodeOnly: true });
if (!supportedLocalesInclude(locale)) {
  locale = process.env.VUE_APP_I18N_LOCALE || "fr";
}

const i18n = createI18n({
  legacy: false, // Pour utiliser la Composition API
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "fr",
  silentTranslationWarn: true, // N'affiche pas les messages "warn" quand les traductions manquent
  globalInjection: true,
  warnHtmlMessage: false, // Désactive les warnings HTML dans les messages
  messages: {
    fr: merge(removeEmptyTradKeys(fr), cfr),
    de: merge(removeEmptyTradKeys(de), cde),
  },
});

// Ce hack permet de réduire le temps de la migration vers Vue3 suite à la suppression de $tc:
// eslint-disable-next-line
// https://vue-i18n.intlify.dev/guide/migration/breaking10#tc-key-key-resourcekeys-choice-number-named-record-string-unknown-translateresult
const _t = i18n.global.t;
i18n.global.t = (key, arg1, arg2) => {
  if (arg2) { // pluralization et variables, appel via: $t("liste.x-article", 3, { article: 3 })
    // On transforme pour être compatible avec vue-i18n v11+ : $t("liste.x-article", { article: 3 }, 3)
    return _t(key, arg2, arg1);
  }

  // Juste variables, appel via : $t("prix.ttc", { prix: "3.11" })
  return _t(key, arg1);
};
// Évolutions à prévoir :
// - Utiliser {count} ou {n} au lieu de clé comme {article} dans les clés de traduction concernant des compteurs
// - Retirer la répétitions du genre: $t("key", compteur, { count: compteur, }) pour $t("key", compteur)

export default i18n;
